import { GzDashboardGridStackManagerWebComponent } from './component/GzDashboardGridStackManagerWebComponent';

export { GzDashboardGridStackManagerWebComponent };
